import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, ButtonLink, IconNewWindow } from "braid-design-system";
import { createContext, useRef, useState, useContext } from "react";
import { translations } from "../../../../components/.vocab/index.mjs";
import { applyButton } from "../../JobDetailsView/JobDetailsView.css.mjs";
import { useMelwaysLink } from "@seek/melways-react";
const noop = () => {
};
const initialState = {
  reportJobAd: {
    ref: null,
    onReportJobAdDropdownClick: noop,
    setOnReportJobAdDropdownClick: noop
  }
};
const JobDetailsViewContext = createContext(initialState);
const useJobDetailsViewContext = () => {
  const {
    onAnalyticsEvent = noop,
    shouldOpenApplyInNewTab = false,
    featureFlags,
    displayCompanyProfile = false,
    shouldShowLinkoutJobRecs = false,
    ...result
  } = useContext(JobDetailsViewContext);
  return {
    ...result,
    onAnalyticsEvent,
    shouldOpenApplyInNewTab,
    featureFlags,
    displayCompanyProfile,
    shouldShowLinkoutJobRecs
  };
};
const useJobDetailsViewContextProviderValue = (props) => {
  const reportJobAdRef = useRef(null);
  const [onReportJobAdDropdownClick, setOnReportJobAdDropdownClick] = useState(() => {
  });
  return {
    ...props,
    reportJobAd: {
      ref: reportJobAdRef,
      onReportJobAdDropdownClick,
      setOnReportJobAdDropdownClick
    }
  };
};
const JobDetailsViewContextProvider = ({
  children,
  ...props
}) => {
  const value = useJobDetailsViewContextProviderValue(props);
  return /* @__PURE__ */ jsx(JobDetailsViewContext.Provider, { value, children });
};
const useQualities = () => {
  const { qualities } = useJobDetailsViewContext();
  const { matched = [], inferred = [], unmatched = [] } = qualities || {};
  return { matched, inferred, unmatched };
};
const insertPathSuffix = (relativeUrl, suffix) => {
  const urlObj = new URL(relativeUrl, "http://example.com");
  return urlObj.pathname + suffix + urlObj.search + urlObj.hash;
};
const isValidAbsoluteUrl = (url) => {
  try {
    return Boolean(new URL(url));
  } catch {
    return false;
  }
};
const checkIfContainLangPrefix = (str) => {
  const regex = /^\/(th|id)\//;
  return regex.test(str);
};
const useApplyUrl = ({
  path,
  renderRelativePaths
}) => {
  const _path = checkIfContainLangPrefix(path) ? path.substring(3) : path;
  const melwaysLink = useMelwaysLink({
    path: _path,
    product: "candidate",
    absolute: !renderRelativePaths
  });
  if (isValidAbsoluteUrl(path)) {
    return path;
  }
  return melwaysLink;
};
const ApplyButton = ({
  job,
  ctas,
  shouldOpenApplyInNewTab,
  size = "standard",
  renderRelativePaths = false
}) => {
  const { t } = useTranslations(translations);
  const applyUrl = useApplyUrl({ path: job.applyUrl, renderRelativePaths });
  const linkoutSuccessUrl = useApplyUrl({
    path: insertPathSuffix(job.applyUrl, "/external"),
    renderRelativePaths
  });
  const { shouldShowLinkoutJobRecs, isLoggedIn } = useJobDetailsViewContext();
  const onClick = () => {
    ctas?.onApplyClick?.();
    if (shouldShowLinkoutJobRecs && job.isLinkOut && isLoggedIn && Boolean(linkoutSuccessUrl)) {
      setTimeout(() => {
        window.location.href = linkoutSuccessUrl;
      }, 100);
    }
  };
  return /* @__PURE__ */ jsx(Box, { className: applyButton, width: "full", children: /* @__PURE__ */ jsx(
    ButtonLink,
    {
      href: applyUrl,
      onClick,
      tone: "brandAccent",
      target: job.isLinkOut || shouldOpenApplyInNewTab ? "_blank" : "",
      icon: job.isLinkOut ? /* @__PURE__ */ jsx(IconNewWindow, { alignY: "lowercase" }) : void 0,
      iconPosition: "trailing",
      "data-automation": "job-detail-apply",
      "aria-label": t("Apply for {jobTitle} at {jobCompanyName}", {
        jobTitle: job.title,
        jobCompanyName: job.company.name
      }),
      size,
      children: job.isLinkOut ? t("Apply") : t("Quick apply")
    }
  ) });
};
export {
  ApplyButton,
  JobDetailsViewContextProvider,
  useJobDetailsViewContext,
  useQualities
};
